import { FavouriteDefinition, Value } from 'app/types-shared';
import { updateSelectedReport } from './selected-report';

export const updateTarget = (
  definition: FavouriteDefinition,
  targetApplication: Value
): FavouriteDefinition => {

  const updatedReportFields = !!targetApplication
    ? {
      targetApp: targetApplication
    }
    : {
      targetApp: undefined
    };
  return updateSelectedReport(definition, updatedReportFields);
};
